import React, { createContext, Dispatch, ReactNode, useReducer } from "react";
import { parseCoordinates } from "common/utils/coordinates";
import { OmniboxSearchResult } from "../../generated/graphql";

type SearchResultsState = {
  debouncedQuery: string | null;
  isTextSearch: boolean | null;
  loading: boolean;
  results: OmniboxSearchResult[] | null;
};

type SearchResultsAction =
  | {
      type: "searchStarted";
      query: string;
    }
  | {
      type: "searchComplete";
      results: OmniboxSearchResult[] | null;
    }
  | {
      type: "resetSearch";
    };

export const INTIAL_SEARCH_RESULTS_STATE: SearchResultsState = {
  debouncedQuery: null,
  isTextSearch: null,
  loading: false,
  results: null,
};

const useSearchResultsState = (
  initialState: SearchResultsState = INTIAL_SEARCH_RESULTS_STATE,
) =>
  useReducer((state: SearchResultsState, action: SearchResultsAction) => {
    switch (action.type) {
      case "searchStarted":
        return {
          ...state,
          loading: true,
          isTextSearch: parseCoordinates(action.query) === null,
          debouncedQuery: action.query,
          results: null,
        };
      case "searchComplete":
        return { ...state, results: action.results, loading: false };
      case "resetSearch":
        return INTIAL_SEARCH_RESULTS_STATE;
    }
  }, initialState);

type SearchResultsContextType = {
  searchResultsState: SearchResultsState;
  searchResultsDispatch: Dispatch<SearchResultsAction>;
};

export const SearchResultsContext = createContext<SearchResultsContextType>(
  {} as SearchResultsContextType,
);

export const SearchResultsContextProvider = ({
  children,
  initialState = INTIAL_SEARCH_RESULTS_STATE,
}: {
  children: ReactNode;
  initialState?: SearchResultsState;
}) => {
  const [searchResultsState, searchResultsDispatch] =
    useSearchResultsState(initialState);

  return (
    <SearchResultsContext.Provider
      value={{ searchResultsState, searchResultsDispatch }}
    >
      {children}
    </SearchResultsContext.Provider>
  );
};
